import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { GetEquipmentsWorkRequestsList } from '../../../store/FLEET/EquipmentsWorkRequests/equipmentsWorkRequestSlice';
import { CardBody, Card, CardHeader } from '../../../components/card/card';
import NtxTable from '../../../components/DataTable/NtxTable';
import Loading from '@components/Shared/Loader/Loading';
import { useNavigate } from 'react-router-dom';

const WorkRequestList: React.FC = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const Navigate = useNavigate();

  useEffect(() => {
    dispatch(GetEquipmentsWorkRequestsList());
  }, [dispatch]);
  const { EquipmentsWorkRequestsList, loading, error } = useAppSelector(state => state.EquipmentsWorkRequest);

  const columns = [
    { title: t('RequestNumber'), key: 'RequestNumber' },
    { title: t('Vehicle'), key: 'Equipment' },
    { title: t('RequestDate'), key: 'RequestDate' },
    { title: t('TypeOfRequest'), key: 'TypeOfRequest' },
    // { title: t('RequestDescription'), key: 'RequestDescription' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = EquipmentsWorkRequestsList?.map(item => {
    let rowClass;

    return {
      RequestNumber: item.requestCode,
      TypeOfRequest: i18n.language === 'ar' ? item.requestTypeName2 : item.requestTypeName,
      RequestDescription: item.requestTitle,
      RequestDate: item.requestDate,
      Equipment: i18n.language === 'ar' ? item.fleetEquipmentsName2 : item.fleetEquipmentsName,

      action: (
        <button
          type='button'
          className='btn btn-sm btn-outline-theme'
          // data-bs-toggle='modal'
          // data-bs-target='#ModalAddOrderMaintenance'
          onClick={() => Navigate(`AddWorkOrder/${item.id}`)}
        >
          {/* <i className="far fa-lg fa-fw me-2 fa-edit"></i> */}
          <i className='  fa-lg fa-fw me-2 fas fa-wrench'></i>
          {t('CreateMaintenanceOrder')}
        </button>
      ),

      rowClass // استخدم rowClass هنا
    };
  });

  return (
    <>
      <Card>
        <CardHeader className='d-flex justify-content-between align-items-center '>
          <h5 className='m-0'>{t('MaintenanceRequests')}</h5>
        </CardHeader>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              // showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>
    </>
  );
};

export default WorkRequestList;
